module.exports = __webpack_public_path__ + "img/model_mt10_small.c1beae94.png";